export enum ModuleName {
  Cloud = 1,
  Construct = 2,
  DefaultCloud = 3,
  AICloud = 4,
  IAMCloud = 5,
  Localization = 6,
  LMT = 7,
  DefaultConstruct = 8,
  AIConstruct = 9,
  IAMConstruct = 10,
  DataGateway = 11,
}
